import { IRootState } from '../../../../../store'
import { IGlassgowCommaScoreState } from '../store/glassgowCommaScore.types'

export const getGlassgowCommaScoreSelector = (state: IRootState): IGlassgowCommaScoreState => state.glassgowCommaScore
